angular.module('jv.Admin.Users.Settings.Service',
    [
        'jv.Admin.Users.URLs.Factory',
        'jv.Admin.Users.Ajax.Factory',
        'jv.Admin.Users.EmployeeSelect.Factory'
    ])
    .service('adminSettingsSVC', function(prepareAjaxCall, jvAdminUsersUrls, employeeSelectFAC, $window) {
        var appendReadMode = function(isReadMode){
            return isReadMode? 'readMode=0' : '';
        };

        this.employeeSelect = employeeSelectFAC;

        this.getEmpFieldSettings = function(callback, fail, readMode) {
            var options = {};
            options = {
                'ajaxtype': 'getAdminUsersSettings',
                'url': jvAdminUsersUrls.getAdminUsersSettings
            };
            if (readMode) {
                options.url += '&readMode=0';
            }
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getImportSettings = function(callback, fail, readMode) {
            var options = {};
            options = {
                'ajaxtype': 'getAdminUsersImportSettings',
                'url': jvAdminUsersUrls.getAdminUsersImportSettings
            };
            if (readMode) {
                options.url += '&readMode=0';
            }
            prepareAjaxCall({}, options, callback, fail);
        };

        this.saveImportSettings = function(data, callback, fail) {
            var options = {
                'ajaxtype': 'postImportSettings',
                'url': jvAdminUsersUrls.postImportSettings,
                'requestType': 'POST',
                'headerType': 'json'
            };
            prepareAjaxCall(data, options, callback, fail);
        };

        this.postEmpSettings = function(data, callback, fail) {
            var options = {
                'ajaxtype': 'postEmployeeFieldSettings',
                'url': jvAdminUsersUrls.postEmployeeFieldSettings,
                'requestType': 'POST',
                'headerType': 'json'
            };
            prepareAjaxCall(data, options, callback, fail);
        };
        
        this.submit = function(response, callback, fail) {
        	var args = response;
        	var options = {
                    'ajaxtype': 'submitMapping',
                    'headerType':'json',
                    'url': jvUrls.admin + '/action/users/datasync/employees/saveColumnMapping',
                    'requestType': 'POST'
                };
        	prepareAjaxCall(args, options, callback, fail);
        };
        
        this.updateMapping = function(response, callback, fail) {
        	var args = response;
        	var options = {
                    'ajaxtype': 'updateMapping',
                    'headerType':'json',
                    'url': jvUrls.admin + '/action/users/datasync/employees/saveColumnMapping/'+response.columnMappingId,
                    'requestType': 'PUT'
                };
        	prepareAjaxCall(args, options, callback, fail);
        };
        
        this.getColumnMapping = function(callback, fail, readMode) {
            var url = jvUrls.admin +'/action/users/datasync/employees/getColumnMappingSettings?{0}';
            url = url.format(appendReadMode(readMode));
            var options = {
                'ajaxtype': 'getColumnMapping',
                'url': url
            };
            prepareAjaxCall({}, options, callback, fail);
        };
        
        this.getSelect2MappingValues = function(employeeSyncKey, fileDelimiter, callback, fail) {
        	var delimiter = "Comma";
        	if(fileDelimiter === '\\t'){
        		delimiter = "Tab";
        	}
        	var url = jvUrls.admin + '/action/users/datasync/employees/sampleData?s3Key='+ employeeSyncKey + '&fileDelimiter=' + delimiter;
            var options = {
                'ajaxtype': 'getSelect2MappingValues',
                'url': url
            };
            prepareAjaxCall({}, options, callback, fail);
        };
        
        this.getUploadedFileDetails = function(callback, fail) {
            var options = {};
            options = {
                'ajaxtype': 'getUploadedFileDetails',
                'url': jvUrls.admin + '/action/users/datasync/employees/logs/0/1?status=ALL&connectorType=S3'
            };
            prepareAjaxCall({}, options, callback, fail);
        };
        
        this.downloadEmployeeSyncFile = function(url) {
        	$window.location = url;
        };

    });
